// import logger from 'redux-logger'
import thunk from 'redux-thunk'
import FeatureMiddleWare from './FeatureMiddleware'
import LocalForageMiddleWare from './LocalForageMiddleware'
import LauncherCommandMiddleware from './LauncherCommandMiddleware'
import NotifierMiddleware from './NotifierMiddleware'
import LoggerMiddleware from './LoggerMiddleware'
import LogoutMiddleware from './LogoutMiddleware'
import ClientLauncherMiddleware from './ClientLauncherMiddleware'
import { featureMiddlewares } from '../features'

const Middlewares = [
    // logger,
    thunk,
    FeatureMiddleWare,
    LauncherCommandMiddleware,
    LocalForageMiddleWare,
    NotifierMiddleware,
    LoggerMiddleware,
    LogoutMiddleware,
    ClientLauncherMiddleware,
    ...featureMiddlewares,
]

export default Middlewares



// WEBPACK FOOTER //
// ./src/middlewares/index.js